import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import api from './helpers/Axios'
import store from './store/index'
import { BootstrapVue } from 'bootstrap-vue'
import storePlugin from './helpers/StorePlugin'
import interceptorsSetup from './helpers/interceptors'

//import fontawesome from '@fortawesome/fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core';
import {faHome} from '@fortawesome/fontawesome-free-solid/faHome';
import {faLock} from '@fortawesome/fontawesome-free-solid/faLock';
import {faComments} from '@fortawesome/fontawesome-free-solid/faComments';
import {faWrench} from '@fortawesome/fontawesome-free-solid/faWrench';
import {faSearch} from '@fortawesome/fontawesome-free-solid/faSearch';
import {faArrowLeft} from '@fortawesome/fontawesome-free-solid/faArrowLeft';
import {faArrowRight} from '@fortawesome/fontawesome-free-solid/faArrowRight';
import {faPrint} from '@fortawesome/fontawesome-free-solid/faPrint';
import {faUpload} from '@fortawesome/fontawesome-free-solid/faUpload';
import {faSave} from '@fortawesome/fontawesome-free-solid/faSave';
import {faMinusCircle} from '@fortawesome/fontawesome-free-solid/faMinusCircle';
import {faPlusCircle} from '@fortawesome/fontawesome-free-solid/faPlusCircle';
import {faTimesCircle} from '@fortawesome/fontawesome-free-solid/faTimesCircle';
import {faEdit} from '@fortawesome/fontawesome-free-solid/faEdit';
import {faChevronCircleDown} from '@fortawesome/fontawesome-free-solid/faChevronCircleDown';
import {faFileExcel} from '@fortawesome/fontawesome-free-solid/faFileExcel';
import {faCheckCircle} from '@fortawesome/fontawesome-free-solid/faCheckCircle';
import {faFilePdf} from '@fortawesome/fontawesome-free-solid/faFilePdf';
import {faAngleDown} from '@fortawesome/fontawesome-free-solid/faAngleDown';
import {faAngleUp} from '@fortawesome/fontawesome-free-solid/faAngleUp';
import {faSpinner} from '@fortawesome/fontawesome-free-solid/faSpinner';
import {faBars} from '@fortawesome/fontawesome-free-solid/faBars';
import '@babel/polyfill'

library.add(faHome, faLock, faComments, faSearch, faArrowLeft, faArrowRight, faPrint, faUpload, faSave, faMinusCircle, faPlusCircle, faTimesCircle, faEdit
  , faChevronCircleDown, faFileExcel, faCheckCircle, faFilePdf, faAngleDown, faAngleUp, faSpinner, faBars, faWrench)
//library.add(faHome);

interceptorsSetup()
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(storePlugin)

Vue.prototype.$http = api;

new Vue({
  router,
  BootstrapVue,
  store,
  api,
  storePlugin,
  render: h => h(App)
}).$mount('#app')
